import src from "IMAGE";
export default { src, width: 553, height: 113, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANElEQVR42hXGsQmAMAAEwJ/TCWwsRAQLFVJkhjSpM2cuxcElSefn4eTlZtBIobKx83FwrU/+8gfU3CeDGwAAAABJRU5ErkJggg=="};
